module.exports = __webpack_public_path__ + "static/media/image-1.f47899ae.png";